import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.CompanyValuationEdit })));
const create = lazy(() => import("./Create").then(m => ({ default: m.CompanyValuationCreate })));

export default { edit, create };
